import React from 'react';

import { Container, FooterLinks } from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <p>
        Copyright &copy; 2022 - <span>SharplyApps</span>
      </p>
      <FooterLinks>
        <a href="/about">Sobre nós</a>
        <a href="/terms">Termos de uso</a>
        <a href="mailto: sharplyapps@gmail.com">Contato</a>
      </FooterLinks>
    </Container>
  );
};

export default Footer;
